"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = exports.ThemeProvider = void 0;
const react_1 = __importStar(require("react"));
const create_theme_1 = require("./create-theme");
const theming_context_1 = require("./theming-context");
function getLocalStorage() {
    if (typeof window === "undefined")
        return null;
    return window.localStorage;
}
const initialScheme = ((_a = getLocalStorage()) === null || _a === void 0 ? void 0 : _a.getItem("color-scheme")) || create_theme_1.defaultScheme;
const SchemeContext = react_1.default.createContext({
    scheme: initialScheme,
    setScheme: (_scheme) => { },
});
function ThemeProvider({ theme, children }) {
    const [scheme, _setScheme] = (0, react_1.useState)(initialScheme);
    const setScheme = (0, react_1.useCallback)(scheme => {
        var _a;
        (_a = getLocalStorage()) === null || _a === void 0 ? void 0 : _a.setItem("color-scheme", scheme);
        _setScheme(scheme);
    }, []);
    theme = theme || theming_context_1.defaultTheme;
    const colorScheme = theme.schemes[scheme].colorScheme || create_theme_1.defaultScheme;
    const defaultOverride = theme.schemes[colorScheme];
    const selectedScheme = theme.schemes[scheme];
    const colors = {
        ...theme.colors,
        ...defaultOverride,
        ...selectedScheme,
    };
    delete colors.colorScheme;
    const result = {
        ...theme,
        colorScheme,
        colors,
    };
    return (react_1.default.createElement(SchemeContext.Provider, { value: { scheme, setScheme } },
        react_1.default.createElement(theming_context_1.Theming.ThemeProvider, { theme: result }, children)));
}
exports.ThemeProvider = ThemeProvider;
function useTheme() {
    const theme = theming_context_1.Theming.useTheme();
    return {
        ...(0, react_1.useContext)(SchemeContext),
        theme,
    };
}
exports.useTheme = useTheme;
exports.default = ThemeProvider;
//# sourceMappingURL=data:application/json;base64,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